<div class="page-container-no-header">
  <div class="header py-4 text-center">
    <img src="/assets/img/logos/logo.svg" alt="logo" loading="lazy">
  </div>
  <div class="container content text-center">
    <img class="my-20" src="/assets/img/full-lock.png" alt="full lock" loading="lazy">
    <div class="text-24 font-weight-700">{{ 't.full-acc-lock-title' | translate }}</div>
    <div class="text-16 my-20">{{ 't.full-acc-lock-desc' | translate }}</div>
    <div class="flex justify-center">
      <button (click)="zendesk.toggle()" class="btn btn--primary">{{ 'link.contact-us' | translate }}</button>
    </div>
    <div (click)="onLogout()" class="flex justify-center">
      <div class="text-14 font-weight-700 my-10 cursor-pointer">
        {{ 'link.logout' | translate }}
      </div>
    </div>
  </div>
</div>
